import React, { useState, useEffect } from 'react';
import TokenManager from "../../utils/tokenManager"; 

const SecureImage = ({ src, alt, className, style, ...props }) => {
  const [imageSrc, setImageSrc] = useState(null);

  useEffect(() => {
    // If there is no source, do nothing
    if (!src) return;

    // If it's already a local preview (blob:) or base64, render it immediately
    if (src.startsWith('blob:') || src.startsWith('data:')) {
      setImageSrc(src);
      return;
    }

    // Otherwise, fetch it from the backend
    const fetchSecureImage = async () => {
      try {
        const token = TokenManager.getAccessToken();
        if (!token) return;

        const response = await fetch(src, {
          method: 'GET',
          headers: {
            'Authorization': `Bearer ${token}`
          }
        });

        if (!response.ok) {
          throw new Error(`Failed to load image: ${response.status}`);
        }

        const blob = await response.blob();
        const localObjectUrl = window.URL.createObjectURL(blob);
        setImageSrc(localObjectUrl);

        // Cleanup memory when component unmounts
        return () => window.URL.revokeObjectURL(localObjectUrl);
      } catch (error) {
        console.error("Error fetching secure image:", error);
      }
    };

    fetchSecureImage();
  }, [src]);

  if (!imageSrc) return null; 

  return <img src={imageSrc} alt={alt} className={className} style={style} {...props} />;
};

export default SecureImage;